import { IconWrapper } from '../runtime';
export default IconWrapper('distribute-vertically', true, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("mask", {
    "attrs": {
      "id": props.id + '6550eaeb',
      "maskUnits": "userSpaceOnUse",
      "x": "0",
      "y": "0",
      "width": "48",
      "height": "48"
    },
    "style": {
      maskType: 'alpha'
    }
  }, [h("rect", {
    "attrs": {
      "width": "48",
      "height": "48",
      "fill": props.colors[2]
    }
  })]), h("g", {
    "attrs": {
      "mask": 'url(#' + props.id + '6550eaeb' + ')'
    }
  }, [h("rect", {
    "attrs": {
      "x": "38",
      "y": "30",
      "width": "28",
      "height": "12",
      "transform": "rotate(180 38 30)",
      "fill": props.colors[1],
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M42 40H6",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M42 8L6 8",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  })])]);
});